
// This is an auto generated file - do not edit!
// Swagger path: /api/LogicStep/{code}/parameters

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    LogicStepParameter
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class LogicstepCodeParametersApiService extends BaseApiService {
    
    get(code: string, options = {}): Observable<LogicStepParameter[]> {
        return this._get<LogicStepParameter[]>(
            `/LogicStep/${code}/parameters`,
            options
        );
    }
}
